import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import usePlans from '../../api/usePlans';
import { PlansTable } from './components/PlansTable';
import PortalHeader from '../../components/PortalHeader/PortalHeader';

import PlanTabs from './PlanTabs';
import { SubscriptionsTable } from './components/SubscriptionsTable';

enum TAB_IDS {
  PLANS = 'Plans',
  SUBSCRIPTIONS = 'Subscriptions'
}

const tabTitles = [TAB_IDS.PLANS, TAB_IDS.SUBSCRIPTIONS];

const Subscriptions = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(TAB_IDS.PLANS);

  // const isEmpty = true;
  const isPageDisabled = false;

  return (
    <div
      className={`${isPageDisabled ? 'opacity-50 pointer-events-none' : 'opacity-100 pointer-events-auto'}`}
    >
      <PortalHeader
        title="Subscriptions List"
        primaryButtonText="Create New Plan"
        onPrimaryButtonClick={() => navigate('./form')}
        isCreateButton
      />

      <div className="px-9 pb-9 pt-2.5">
        <PlanTabs
          tabs={tabTitles}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
        {activeTab === TAB_IDS.PLANS && <PlansTable />}
        {activeTab === TAB_IDS.SUBSCRIPTIONS && <SubscriptionsTable />}
      </div>
    </div>
  );
};

export default Subscriptions;
